export enum CoreClientContactApiTags {
  ClientContactList = 'ClientContactList',
  AnotherClientContactList = 'AnotherClientContactList',
  ClientContactCanView = 'ClientContactCanView',
  ClientContactCanOpen = 'ClientContactCanOpen',
}

export const coreClientContactApiTagTypes = Object.values(CoreClientContactApiTags);
